<template>
    <modal
        :is-open="isOpen"
        :is-loading="loading"
        :disabled="loading"
        title="Запрос доступа"
        btn-save-title="Отправить запрос"
        :btn-save-classes="['order-1', 'order-md-2']"
        :btn-cancel-classes="['order-2', 'order-md-1']"
        :footer-classes="['flex-wrap']"
        @onCloseModal="closeModal"
        @onSaveModal="confirmModal"
    >
        Запросив доступ к скрытым изделиям, вы получите возможность
        просматривать расширенный каталог изделий бренда. <br /><br />
        Поставщик бренда
        <strong>“{{ brand && brand.BrandName }}”</strong>
        получит уведомление о вашем запросе и рассмотрит его.
    </modal>
</template>

<script>
import Modal from '@/components/Elements/Modal'

export default {
    name: 'RequestAccessModal',
    components: { Modal },
    props: {
        brand: {
            type: [Object, null],
            default: null
        },
        isOpen: {
            type: Boolean,
            default: false
        }
    },
    data() {
        return {
            loading: false
        }
    },
    methods: {
        closeModal() {
            this.$emit('onClose')
        },
        confirmModal() {
            this.$emit('onConfirm', this.brand)
        }
    }
}
</script>
